export default "__VITE_ASSET__c7bceb05__"